<template>

  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-checklist-report-extract-by-occurrence"
      default-excel
      modal
      enable-generate-pdf
      enable-generate-excel
      enable-generate-word
      java-report
      button-title="Extrato"
      title="Extrato de Apontamentos">

    <t-input-search v-model="form.issueDate" date enable-range
                    label="Data Abertura"/>



    <t-input-code-label enterprise
                        v-model="form.enterpriseId"/>


    <t-input-search v-model="form.sectorId" :options="sectorOptions"
                    label="Categoria"
                    select/>


    <t-input-person executor
                    v-model="form.executorId"/>


    <t-input-code-label inspector
                        v-model="form.inspectorId"/>

    <t-input-search v-model="form.occurrenceStatusId" :options="typeOccurrenceStatusOptions"
                    label="Status Apontamento" radio

    />


  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import SectorService from "@/services/modules/agent/Sector.service";
import TypeCriticalityService from "@/services/modules/checklist/TypeCriticality.service";
import TypeOccurrenceStatusService from "@/services/modules/checklist/TypeOccurrenceStatus.service";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportExtractOccurrence',
  data() {
    return {
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        issueDate:"",
        enterpriseId:0,
        sectorId:0,
        executorId:0,
        inspectorId:0,
        hasOccurrencePending:null,
        occurrenceStatusId:0,
      },
      sectorOptions: [],
      typeOccurrenceStatusOptions: [],
      typeCriticalityOptions: [],

    }
  },
  props: {},
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await SectorService.selectList("").then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))


      await TypeCriticalityService.selectList("").then((list) => {
        this.typeCriticalityOptions = list
      }).catch(error => this.responseError(error))

      await TypeOccurrenceStatusService.selectList("").then((list) => {
        this.typeOccurrenceStatusOptions = list
      }).catch(error => this.responseError(error))

    },


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
